import styled from "styled-components";

export const Page = styled.div`
  height: 100%;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  background: #f7f9fc;
  color: #1b2028;
  font-family: "Manrope", sans-serif;
`;

export const Header = styled.div`
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 24px;
  padding: 28px 32px 16px;
`;

export const Title = styled.h1`
  margin: 0;
  font-size: 26px;
  line-height: 34px;
  font-weight: 700;
`;

export const Subtitle = styled.p`
  margin: 5px 0 0;
  color: #66758a;
  font-size: 14px;
  max-width: 560px;
`;

export const HeaderActions = styled.div`
  display: flex;
  gap: 10px;
  align-items: center;
`;

export const Body = styled.div`
  flex: 1;
  min-height: 0;
  display: grid;
  grid-template-columns: 280px minmax(0, 1fr);
  gap: 20px;
  padding: 0 32px 28px;

  @media (max-width: 900px) {
    grid-template-columns: minmax(0, 1fr);
  }
`;

export const TreePanel = styled.div`
  min-height: 0;
  overflow-y: auto;
  padding: 12px;
  border: 1px solid #dde2e9;
  border-radius: 12px;
  background: #fff;
  box-shadow: 0 3px 12px rgba(18, 38, 63, 0.04);
`;

export const ListPanel = styled.div`
  min-height: 0;
  display: flex;
  flex-direction: column;
  border: 1px solid #dde2e9;
  border-radius: 12px;
  background: #fff;
  box-shadow: 0 3px 12px rgba(18, 38, 63, 0.04);
  overflow: hidden;
`;

export const Breadcrumb = styled.div`
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 4px;
  padding: 14px 18px;
  border-bottom: 1px solid #edf0f5;
  font-size: 13px;
  color: #536176;
`;

export const BreadcrumbCrumb = styled.button`
  border: 0;
  background: none;
  padding: 2px 4px;
  font-size: 13px;
  color: ${(props) => (props.$current ? "#172033" : "#0c53bb")};
  font-weight: ${(props) => (props.$current ? 700 : 500)};
  cursor: ${(props) => (props.$current ? "default" : "pointer")};

  &:hover {
    text-decoration: ${(props) => (props.$current ? "none" : "underline")};
  }
`;

export const ListBody = styled.div`
  flex: 1;
  min-height: 0;
  overflow-y: auto;
`;

export const Row = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 11px 18px;
  border-bottom: 1px solid #f0f2f6;
  cursor: ${(props) => (props.$clickable ? "pointer" : "default")};

  &:hover {
    background: #f7f9fc;
  }
`;

export const RowIcon = styled.span`
  display: inline-flex;
  flex-shrink: 0;
`;

export const RowName = styled.span`
  flex: 1;
  min-width: 0;
  font-size: 14px;
  color: #1b2028;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`;

export const RowMeta = styled.span`
  flex-shrink: 0;
  font-size: 12px;
  color: #8492a6;
  min-width: 80px;
  text-align: right;
`;

export const EmptyState = styled.div`
  padding: 56px 20px;
  margin: 20px;
  border: 1px dashed #ccd4df;
  border-radius: 12px;
  background: #fbfcfe;
  text-align: center;
  color: #66758a;
`;

export const ErrorBanner = styled.div`
  margin: 16px 32px 0;
  padding: 10px 14px;
  border-radius: 8px;
  background: #fdecec;
  color: #b42318;
  font-size: 13px;
`;

export const Warning = styled.div`
  margin: 12px 0;
  padding: 10px 12px;
  border-radius: 8px;
  background: #fff8e6;
  color: #7a5412;
  font-size: 12px;
  line-height: 18px;
`;

export const FilterLabel = styled.label`
  display: flex;
  flex-direction: column;
  gap: 5px;
  color: #536176;
  font-size: 12px;
  font-weight: 600;
`;

export const MatterResults = styled.div`
  max-height: 180px;
  margin-top: 6px;
  overflow-y: auto;
  border: 1px solid #e1e6ee;
  border-radius: 8px;
`;

export const MatterResult = styled.button`
  width: 100%;
  padding: 9px 11px;
  border: 0;
  border-bottom: 1px solid #edf0f5;
  background: ${(props) => (props.$selected ? "#edf5ff" : "#fff")};
  color: #344054;
  text-align: left;
  cursor: pointer;

  &:last-child {
    border-bottom: 0;
  }

  &:hover {
    background: #edf5ff;
  }
`;

export const ReaderBody = styled.div`
  position: relative;
  height: ${(props) => (props.$embedded ? "100%" : "calc(100vh - 170px)")};
  min-height: ${(props) => (props.$embedded ? "0" : "420px")};
  background: #f3f0fa;
`;

export const ViewerPanel = styled.div`
  height: 100%;
  min-height: 0;
  display: flex;
  flex-direction: column;
`;

export const ViewerToolbar = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  padding: 12px 18px;
  border-bottom: 1px solid #edf0f5;
`;

export const ViewerTitleGroup = styled.div`
  min-width: 0;
  display: flex;
  flex-direction: column;
  gap: 2px;
`;

export const ViewerTrail = styled.span`
  font-size: 12px;
  color: #8492a6;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`;

export const ViewerFileName = styled.span`
  font-size: 14px;
  font-weight: 700;
  color: #1b2028;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`;

export const ViewerActions = styled.div`
  flex-shrink: 0;
  display: flex;
  align-items: center;
  gap: 6px;
`;

export const ViewerActionButton = styled.button`
  display: inline-flex;
  align-items: center;
  gap: 5px;
  padding: 6px 10px;
  border-radius: 7px;
  border: 1px solid #dde2e9;
  background: #fff;
  color: ${(props) => (props.$danger ? "#c63939" : "#344054")};
  font-size: 12px;
  font-weight: 600;
  cursor: pointer;
  white-space: nowrap;

  &:hover {
    background: ${(props) => (props.$danger ? "#fdecec" : "#f7f9fc")};
  }
`;

export const ViewerCloseButton = styled.button`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  padding: 6px;
  margin-left: 4px;
  border-radius: 7px;
  border: 1px solid transparent;
  background: transparent;
  color: #66758a;
  cursor: pointer;

  &:hover {
    background: #f0f2f6;
  }
`;

export const ViewerBody = styled.div`
  flex: 1;
  min-height: 0;
  position: relative;
  background: #e7ebf1;
`;

export const ReaderStatus = styled.div`
  display: flex;
  width: 100%;
  height: 100%;
  padding: 32px;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  gap: 10px;
  color: #66758a;
  font-size: 14px;
  text-align: center;
`;

export const LinkBox = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 10px 12px;
  border: 1px solid #dde2e9;
  border-radius: 8px;
  background: #f7f9fc;
  font-size: 13px;
  word-break: break-all;
`;
